import { inject, Injectable }                                                                          from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable }                                                                                  from 'rxjs';
import { map }                                                                                         from 'rxjs/operators';

import { InternalRoutes }        from '../../../shared/data/internal-routes';
import { AuthenticationService } from '../authentication.service';

@Injectable({
  providedIn: 'root'
})
export class PublicPageGuard implements CanActivate, CanActivateChild {
  private auth = inject(AuthenticationService);
  private router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.auth.isAuthenticated().pipe(map(isAuthenticated => {
      const ssoPathFollowing = next.url.some(nextUrl => InternalRoutes.SSO.includes(nextUrl.path));

      return (isAuthenticated && !ssoPathFollowing)
        ? this.router.parseUrl('/')
        : true;
    }));
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.canActivate(next, state);
  }
}
